import axiosClient, { checkoutPaymentServiceAxiosClient } from './base'

export const retrieveCapability = (stripeAccount) =>
	axiosClient.get(`/api/accounts/${stripeAccount}/check_payments`)

export const inviteNewAccount = ({ email, practiceName }) =>
	axiosClient.post('/api/accounts/invitation', { email, practiceName })

export const listAccountsInvitations = ({ pageNumber, pageSize }) =>
	axiosClient.get('/api/accounts/invitation', {
		params: {
			pageNumber,
			pageSize
		}
	})

export const createStripeAccountLink = ({
	stripeAccountId,
	collect,
	futureRequirements,
	refreshURL,
	returnURL
}: ICreateAccountLinkParams) =>
	checkoutPaymentServiceAxiosClient.post('/account-link', {
		account_id: stripeAccountId,
		collection_fields: collect,
		future_requirements: futureRequirements,
		refresh_url: refreshURL,
		return_url: returnURL
	})
